import { CALL_API } from '../../middleware/api';
import { TRANSFORM } from '../../middleware/transform';
import * as ActionTypes from '../popular';
import { siteType } from '../../constants/configMap';
export function fetchPopularMatches(data) {
    var languageId = data.languageId, count = data.count;
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: ActionTypes.FETCH_POPULAR_MATCHES
            },
            _a[CALL_API] = {
                endpoint: "/api/event/popular?languageId=".concat(languageId, "&count=").concat(count, "&siteType=").concat(siteType),
                method: 'get',
                types: [
                    ActionTypes.SUCCESS_FETCH_POPULAR_MATCHES,
                    ActionTypes.FAILURE_FETCH_POPULAR_MATCHES
                ],
                data: data
            },
            _a[TRANSFORM] = {
                section: 'popularMatches',
                transformType: 'init',
                provider: function (data) { return data; }
            },
            _a));
    };
}
export function clearPopular() {
    return function (dispatch) { return dispatch({ type: ActionTypes.CLEAR_POPULAR, section: 'popularMatches' }); };
}



// WEBPACK FOOTER //
// ./src/actions/creators/popular.js